const AUTH_FLOW_KEY = 'auth-flow';

export type AuthFlow = 'sign_up' | 'login';

export const setAuthFlow = (flow: AuthFlow) => {
  localStorage.setItem(AUTH_FLOW_KEY, flow);
};

export const getAuthFlow = (): AuthFlow | null => {
  const flow = localStorage.getItem(AUTH_FLOW_KEY);

  return flow === 'sign_up' || flow === 'login' ? flow : null;
};

export const clearAuthFlow = () => {
  localStorage.removeItem(AUTH_FLOW_KEY);
};
